var render = function render(){var _vm=this,_c=_vm._self._c;return _c('L1',[_c('RadioTop',{attrs:{"slot":"slot_title","defaultValue":_vm.page,"options":['優惠折扣設定', '服務費設定']},on:{"input":function($event){_vm.page=$event}},slot:"slot_title"}),(_vm.page==='優惠折扣設定')?_c('Discount'):_c('Service')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }